import React from 'react';
import { X, Shield, DollarSign, CheckCircle, Phone, Truck, RotateCcw, Lock, FileText, Info, HelpCircle } from 'lucide-react';

const iconMap = {
  Shield,
  DollarSign,
  CheckCircle,
  Phone,
  Truck,
  RotateCcw,
  Lock,
  FileText,
  Info,
  HelpCircle,
};

const ContentPageModal = ({ isOpen, onClose, page }) => {
  if (!isOpen || !page) return null;

  const IconComponent = page.icon ? iconMap[page.icon] : FileText;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white dark:bg-gray-900 rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden animate-in fade-in zoom-in duration-200">
        {/* Header */}
        <div className="sticky top-0 z-10 bg-gradient-to-r from-teal-600 to-cyan-600 px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              {IconComponent && (
                <div className="p-2 bg-white/20 rounded-lg">
                  <IconComponent className="w-6 h-6 text-white" />
                </div>
              )}
              <h2 className="text-xl font-bold text-white">{page.title}</h2>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-white/20 rounded-lg transition-colors"
            >
              <X className="w-5 h-5 text-white" />
            </button>
          </div>
          {page.excerpt && (
            <p className="mt-2 text-white/80 text-sm">{page.excerpt}</p>
          )}
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(85vh-120px)]">
          <div 
            className="prose prose-gray dark:prose-invert max-w-none
              prose-headings:text-gray-900 dark:prose-headings:text-white
              prose-h1:text-2xl prose-h1:font-bold prose-h1:mb-4
              prose-h2:text-xl prose-h2:font-semibold prose-h2:mt-6 prose-h2:mb-3
              prose-p:text-gray-600 dark:prose-p:text-gray-300 prose-p:leading-relaxed
              prose-ul:my-4 prose-li:text-gray-600 dark:prose-li:text-gray-300
              prose-strong:text-gray-900 dark:prose-strong:text-white
              prose-a:text-teal-600 hover:prose-a:text-teal-700"
            dangerouslySetInnerHTML={{ __html: page.content }}
          />
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-gray-50 dark:bg-gray-800 px-6 py-4 border-t border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-between">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Need more help? <button className="text-teal-600 hover:underline">Contact us</button>
            </p>
            <button
              onClick={onClose}
              className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentPageModal;
